export default __webpack_public_path__ + "static/logo10-b84bc11d6710407195c9b3c6117912f8.png";